var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg60Fps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_175_35719)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_175_35719",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_175_35719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3269 33.2857H41.3294V14.7143H31.3269V33.2857ZM31.3269 37C30.3073 37 29.4406 36.6389 28.7269 35.9167C28.0132 35.1944 27.6563 34.3174 27.6563 33.2857V14.7143C27.6563 13.6825 28.0132 12.8056 28.7269 12.0833C29.4406 11.3611 30.3073 11 31.3269 11H41.3294C42.349 11 43.2157 11.3611 43.9294 12.0833C44.6431 12.8056 45 13.6825 45 14.7143V33.2857C45 34.3174 44.6431 35.1944 43.9294 35.9167C43.2157 36.6389 42.349 37 41.3294 37H31.3269Z",
    fill: "#0BAB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67062 33.2857H17.6731V14.7143H7.67062V33.2857ZM7.67062 37C6.65101 37 5.78433 36.6389 5.07058 35.9167C4.35686 35.1944 4 34.3174 4 33.2857V14.7143C4 13.6825 4.35686 12.8056 5.07058 12.0833C5.78433 11.3611 6.65101 11 7.67062 11H17.6731C18.6927 11 19.5593 11.3611 20.2731 12.0833C20.9868 12.8056 21.3437 13.6825 21.3437 14.7143V33.2857C21.3437 34.3174 20.9868 35.1944 20.2731 35.9167C19.5593 36.6389 18.6927 37 17.6731 37H7.67062Z",
    fill: "#0BAB47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 34,
    width: 3,
    height: 3,
    fill: "#0BAB47"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_35719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg60Fps);
export default __webpack_public_path__ + "static/media/60fps.8d79db3006303493ea416daead5e6d27.svg";
export { ForwardRef as ReactComponent };